import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { usePutResetPassword } from "common/hooks/user/account/usePutResetPassword";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";
import { errorMsgHandler, regPassword } from "common/hooks/utils/utils";
import Header from "user/components/common/Header";
import { PasswordInputField } from "user/components/common/InputField";
import { ComplateOverlay, SystemPopup } from "user/components/common/Overlay";

type InitialValuesProps = {
    new_password: string;
    new_password_check: string;
};

const initialValues: InitialValuesProps = {
    new_password: "",
    new_password_check: "",
};

export default function ResetPassword() {
    const { overlay, openOverlay, closeOverlay } = useOverlay();
    const params = useParams();
    // const idx = params?.idx;
    // const token = params?.token;
    // console.log(params);

    // if (!idx && !token) return <Navigate to="/" replace />;

    const { mutate: mutatePassword } = usePutResetPassword();

    const formik = useFormik({
        initialValues,
        onSubmit(values, formikHelpers) {
            formikHelpers.setSubmitting(true);
            onSubmitResetPassword(values);
        },
        validate(values) {
            const errors: Record<string, string> = {};

            if (!values.new_password || !regPassword.test(values.new_password)) {
                errors.new_password = "영문 숫자 조합 6자리 이상 입력하세요.";
            }
            if (!values.new_password_check || !regPassword.test(values.new_password_check)) {
                errors.new_password_check = "영문 숫자 조합 6자리 이상 입력하세요.";
            }
            if (values.new_password !== values.new_password_check) {
                errors.new_password_check = "비밀번호가 일치하지 않습니다.";
            }

            return errors;
        },
        // validateOnMount: true,
    });

    const errorKeys = Object.keys(formik.errors);
    const isInValid = errorKeys.length > 0;

    // 비밀번호 재설정
    const onSubmitResetPassword = async (valuse: InitialValuesProps) => {
        if (params.idx && params.token) {
            const body = {
                member_idx: Number(params.idx),
                token: params.token,
                new_password: valuse.new_password,
            };

            mutatePassword(
                { ...body },
                {
                    onSuccess: () => {
                        openOverlay(
                            <ComplateOverlay
                                headerTitle="비밀번호 재설정 완료"
                                title="비밀번호 재설정 완료"
                                content={
                                    <div className="max-w-[250px]">비밀번호가 재설정되었습니다. 변경한 비밀번호로 로그인해주세요.</div>
                                }
                            />,
                        );
                    },
                    onError: (error: any) => {
                        const err_msg = errorMsgHandler(error);
                        // console.log(err_msg);
                        openOverlay(<SystemPopup message={err_msg} onClickClose={closeOverlay} />);
                    },
                },
            );
        }
    };

    return (
        <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
            <div className="max-h-[100dvh] min-h-[100dvh] bg-white flex flex-col relative">
                <Header goBack title="비밀번호 재설정" />

                <form onSubmit={formik.handleSubmit} className="flex flex-col flex-1">
                    <div className="wrapper flex-1 flex flex-col justify-between py-[16px] w-full">
                        <div className="flex flex-col gap-3">
                            <div className={`flex flex-col`}>
                                <label htmlFor="new_password" className="mb-[4px] text-[#484964] leading-[24px]">
                                    비밀번호
                                </label>

                                <PasswordInputField
                                    id="new_password"
                                    name="new_password"
                                    value={formik.values.new_password}
                                    onChange={formik.handleChange}
                                    placeholder="영문 숫자 조합 6자리 이상"
                                    error={formik.touched.new_password && errorKeys.includes("new_password")}
                                    onClickClearButton={() => formik.setFieldValue("new_password", "")}
                                />

                                {formik.touched.new_password && formik.errors.new_password && (
                                    <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">{formik.errors.new_password}</div>
                                )}
                            </div>

                            <div className={`flex flex-col`}>
                                <label htmlFor="new_password_check" className="mb-[4px] text-[#484964] leading-[24px]">
                                    새 비밀번호 재입력
                                </label>

                                <PasswordInputField
                                    id="new_password_check"
                                    name="new_password_check"
                                    value={formik.values.new_password_check}
                                    onChange={formik.handleChange}
                                    placeholder="영문 숫자 조합 6자리 이상"
                                    error={formik.touched.new_password_check && errorKeys.includes("new_password_check")}
                                    onClickClearButton={() => formik.setFieldValue("new_password_check", "")}
                                />
                                {formik.touched.new_password_check && formik.errors.new_password_check && (
                                    <div className="text-[#DC2626] flex gap-[6px] text-[14px] mt-[4px]">
                                        {formik.errors.new_password_check}
                                    </div>
                                )}
                            </div>
                        </div>
                        <button
                            type="submit"
                            data-disabled={isInValid}
                            className="shadow-custom bg-[#273219] text-white font-bold text-[18px] leading-[28px] py-[12px] rounded-[12px] w-full data-[disabled='true']:opacity-[0.3]"
                        >
                            저장
                        </button>
                    </div>
                </form>
            </div>
        </OverlayWrapper>
    );
}
